import React from "react";

import { IUser } from "@typings/global.types";

interface HtmlSpanProps {
  html?: string;
  classes?: string;
}

function HtmlSpan({ html, classes }: HtmlSpanProps) {
  return (
    <span
      className={classes}
      dangerouslySetInnerHTML={{ __html: html || "" }}
    />
  );
}

export function renderCost(
  isBirthDay: boolean,
  prices: IUser["prices"] | undefined,
) {
  if (isBirthDay && prices) {
    return (
      <>
        <HtmlSpan classes='line-through' html={prices.donate} />
        {"  "}
        <HtmlSpan html={prices.remove_ads} />
      </>
    );
  }
  return prices ? <HtmlSpan html={prices.remove_ads} /> : null;
}

export default HtmlSpan;
